export const mediaChecklistIndoorOptions = [
  'Unit access',
  'Wide view',
  'Close view',
  'Nameplate',
  'Disconnect',
  'Drain location',
  'Ventilation path',
  'Electrical panel',
];

export const mediaChecklistOutdoorOptions = [
  'Unit access',
  'Wide view',
  'Close view',
  'Nameplate',
  'Disconnect',
  'Gas meter',
];
